import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BusquedaTesoroNivelesPage } from './busqueda-tesoro-niveles';
import { ComponentsModule } from '../../components/components.module';
import { LottieAnimationViewModule } from 'ng-lottie';

@NgModule({
  declarations: [
    BusquedaTesoroNivelesPage,
  ],
  imports: [
    IonicPageModule.forChild(BusquedaTesoroNivelesPage),
    ComponentsModule,
    LottieAnimationViewModule.forRoot()
  ],
})
export class BusquedaTesoroNivelesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-niveles/busqueda-tesoro-niveles.module.ts